import { apiClient, Auth } from '@/shared/api'

import { TRefundCard } from '../model/schema'

export const getGuestRefundCard = async (contractId: number) => {
  const { data } = await apiClient.get<TRefundCard>({
    endpoint: `/guest/contracts/${contractId}/refund-card`,
    auth: Auth.REQUIRED,
  })

  return data
}
